import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { FaHeart, FaUsers, FaRing, FaHospital, FaMosque, FaChild, FaBuilding, FaPrayingHands, FaGlobe, FaHandsHelping, FaExternalLinkAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import useCreateUpdatePost from "../../hooks/post/useCreateUpdatePost.js";
import { getToken } from '../../storage/LocalStorageService.js';
import { useNavigate, Link } from "react-router-dom";


const AboutAddaZakat = () => {
  const { t } = useTranslation('about-az');
  const translation = t("about-addazakat");
  const { access_token } = getToken();
  const navigate = useNavigate();


  // Variants for animations to reveal sections on scroll
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const {openCreate} = useCreateUpdatePost();

  const handleCreatePostClick = () => {
    if (access_token) {
      openCreate();
    } else {
      navigate('/auth/login');
    }
  };

  return (
    <>
      <Helmet>
        <title>AddaZakat</title>
        <meta
          name="description"
          content="Discover AddaZakat's mission to connect donors with those in need through a transparent, secure, and direct Zakat platform since 2023."
        />
        <meta
          name="keywords"
          content="About AddaZakat, Zakat, Islamic Charity, Donations, Charity Platform, Needy Families, Medical Assistance, Masjid Support, Orphans Support, Sadaqah, Verified Donations, online zakat payment, zakat fund online registration pakistan, how to donate zakat, zakat form, how to pay zakat online, i need zakat help in pakistan, apply for zakat fund in pakistan, zakat fund help request online, zakat near me, donate zakat online, give zakat online, pay zakat online, donate zakat pakistan, zakat donation portal, online zakat, zakat pakistan, zakat fund, zakat donations, zakat in islam, muslim zakat, zakat fund in pakistan, who is eligible for fitrana, sadaqah online, fidya rules, fitrana amount, when to pay zakat, how to give zakat in islam, how to pay zakat, when should i pay zakat, 1 lakh par kitni zakat hai, zakat donation reviews, donor feedback, zakat success stories, contact adda zakat, zakat helpline, zakat support, charity contact pakistan, Create Zakat Post Online, Update Zakat Post, Zakat Seeker Registration, Online Donation Post Creation, Zakat Application Guidelines, Islamic Charity Post Creation, Zakat for Needy Families, Donation for Widows, Zakat for Orphans Online, Medical Zakat Assistance, Marriage Support Zakat, Masjid Zakat Funding, Madrasa Donation Post, NGO Donation Platform, Zakat Seeker Verification, Upload Zakat Documents, Zakat Bank Details Submission, Seeker Video Upload for Zakat, Zakat Eligibility Guidelines, How to Create Zakat Post, Zakat Post Submission Process, Zakat for Medical Patients. Online Zakat Help Pakistan, Zakat Fund Application, Charity Post Creation Guide, Zakat Document Requirements, Zakat for Bride Support, Islamic Charity Verification, Zakat Post Approval Process, Donate to Masjid Online, Zakat for Madrasa Projects, Orphan Zakat Assistance, Widow Zakat Support, Zakat Seeker Situation Upload, Zakat Payment via CNIC, Online Zakat Donation Platform, Zakat Post Guidelines Pakistan, How to Apply for Zakat Fund, Zakat for Family Assistance, Create Donation Post Online, Zakat Seeker Profile Creation, Zakat Post Review Process, Upload Medical Bills for Zakat, Zakat for Marriage Expenses, Zakat Post Creation Tips, Islamic Donation Post Guidelines, Zakat Seeker Document Upload, Zakat for Community Projects, Online Charity Post Submission, Zakat Application Pakistan, Zakat Post Creator Guide, Zakat, Masarif e Zakat, Islamic Charity, Zakat Recipients, Fisabilillah, Gharimeen, Ibn Sabeel, Poor Needy Muslims, who is eligible for zakat, eligible for zakat, who is eligible to pay zakat, who pays zakat, donate zakat pakistan, zakat donation portal, online zakat, zakat pakistan, zakat fund, zakat donations, zakat in islam, muslim zakat, zakat fund in pakistan, Zakat eligibility, who can receive Zakat, Zakat recipients, Islamic charity, Zakat for poor people, Zakat for needy, Zakat administrators, Zakat for new Muslims, Zakat for slaves, Zakat for debt relief, Zakat for Allah's cause, Zakat for travelers, giving Zakat to relatives, Zakat in Islam, purifying wealth, Sadaqah, Islamic giving, charity for poor families, Zakat rules, Zakat categories, فقراء کے لیے زکوٰۃ, مساکین کے لیے زکوٰۃ, زکوٰۃ کے مستحق, اسلامی خیرات, زکوٰۃ کے اصول, قرض کی ادائیگی کے لیے زکوٰۃ, رشتہ داروں کو زکوٰۃ دینا, اللہ کی راہ میں زکوٰۃ, مسافروں کے لیے زکوٰۃ, صدقہ, زکوٰۃ کی شرائط, who is eligible for Zakat in Islam, how to give Zakat, Zakat and charity, Islamic obligations Zakat, Zakat for community support, About Adda zakat foundation, AddaZakat, Zakat, Islamic Charity, Donations, Charity Platform, Needy Families, Medical Assistance, Masajid Support, Orphans Support, Sadaqah, Verified Donations, Who are Adda Zakat, online zakat payment, zakat fund online registration pakistan,how to donate zakat, zakat form, how to pay zakat online, i need zakat help in pakistan, apply for zakat fund in pakistan, zakat fund help request online, zakat near me, donate zakat online, give zakat online, pay zakat online, donate zakat pakistan, zakat donation portal, online zakat, zakat pakistan, zakat fund, zakat donations, zakat in islam, muslim zakat, zakat fund in pakistan, who is eligible for fitrana, sadaqah online, fidya rules, fitrana amount, when to pay zakat, how to give zakat in islam, how to pay zakat, when should i pay zakat, 1 lakh par kitni zakat hai, zakat donation reviews, donor feedback, zakat success stories, contact adda zakat, zakat helpline, zakat support, charity contact pakistan, donate zakat online, give zakat online, pay zakat online, donate zakat pakistan, zakat donation portal, online zakat, zakat pakistan, zakat fund, zakat donations, zakat in islam, muslim zakat, zakat fund in pakistan, Zakat Calculator, Online Zakat Calculator, Zakat Calculation Tool, Calculate Zakat Online, Zakat on Cash Calculator, Zakat on Gold Calculator, Zakat on Silver Calculator, Zakat on Land and Property, Zakat on Investments, Business Zakat Calculator, Nisab Zakat Calculator, Zakat Rules and Calculation, Zakat Percentage Calculator, Zakat Guide Online, Zakat Payment Calculator, Zakat Calculator Pakistan, Zakat Calculator Saudi Arabia, Zakat Calculator UAE, Zakat Calculator UK, Zakat Calculator USA, How to calculate Zakat on gold and silver, Accurate online Zakat calculator with Nisab, Zakat calculation based on today’s gold rate, Easy Zakat calculator with privacy, Step-by-step Zakat calculation online, Zakat Calculator 2025"
        />
        <meta name="author" content="AddaZakat Team" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:title" content="About AddaZakat - Serving Humanity Since 2023" />
        <meta
          property="og:description"
          content="AddaZakat bridges donors and the needy with transparent, fee-free Zakat distribution to support families, patients, and communities."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://addazakat.com/about" />
        <meta property="og:image" content="https://addazakat.com/assets/images/az-logo.png" />
        <meta property="og:image:alt" content="AddaZakat Logo" />
        <meta property="og:site_name" content="AddaZakat" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About AddaZakat - Serving Humanity Since 2023" />
        <meta
          name="twitter:description"
          content="Join AddaZakat’s mission to deliver Zakat directly and privately to those in need, supporting families, orphans, and more."
        />
        <meta name="twitter:image" content="https://addazakat.com/assets/images/az-logo.png" />
        <meta name="twitter:image:alt" content="AddaZakat Logo" />
        <link rel="canonical" href="https://addazakat.com/about" />

        {/* Structured Data (JSON-LD) for Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "AddaZakat",
            "url": "https://addazakat.com",
            "logo": "https://addazakat.com/assets/images/az-logo.png",
            "description": "AddaZakat is a platform connecting donors with those in need through transparent and secure Zakat distribution.",
            "sameAs": [
              "https://twitter.com/addazakat",
              "https://facebook.com/addazakat",
              "https://instagram.com/addazakat"
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "Customer Service",
              "email": "support@addazakat.com",
              "url": "https://addazakat.com/contact"
            }
          })}
        </script>
      </Helmet>

      <main className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900/20 text-gray-800 dark:text-gray-200 flex flex-col items-center px-2 py-16 md:py-24">
        <section className="max-w-4xl w-full space-y-20">
          {/* Hero Section - First to grab attention */}
          <motion.header 
            className="text-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
          >
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-500">
              {translation.heading}
            </h1>
            <div className="relative max-w-3xl mx-auto">
              <div className="absolute -top-2 -left-6 w-4 h-4 rounded-full bg-teal-400 animate-ping opacity-75"></div>
              <p className="text-lg sm:text-xl md:text-2xl text-gray-700 dark:text-gray-300 leading-relaxed">
                {translation.message1}
              </p>

              <div className="absolute -bottom-2 -right-6 w-4 h-4 rounded-full bg-blue-400 animate-ping animation-delay-1000 opacity-75"></div>

              <Link 
                to="/posts" 
                className="inline-flex bg-gradient-to-r from-blue-600 to-rose-500 text-white font-semibold py-3 px-6 rounded-full hover:shadow-lg hover:-translate-y-1 transition-all mt-5 duration-300 space-x-2"
              > 
                <FaExternalLinkAlt className="text-xl mx-2" />
                <span>{translation.click_to_view}</span>
              </Link>
            </div>

          </motion.header>

          {/* Process for Paying Zakat - Similar timeline, follows receiving process for symmetry */}
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
             <motion.section 
              className="relative bg-gradient-to-r from-blue-600 to-teal-500 rounded-3xl p-6 sm:p-8 md:p-10 text-white shadow-2xl overflow-hidden mb-12 md:mb-16 "
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={sectionVariants}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
              <div className="relative z-10 text-center max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">{translation.donor_process0}</h2>
                <p className="text-lg md:text-xl leading-relaxed">
                  {translation.those_donor_msg}
                </p>
              </div>
            </motion.section>

           
            <div className="space-y-12 md:space-y-16 relative before:absolute before:inset-0 before:w-1 before:mx-auto before:rounded-full md:before:hidden">
              <motion.article 
                className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-teal-100 to-blue-100 dark:from-teal-900/30 dark:to-blue-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold ">1</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.donor_processH1}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.donor_process1}
                  </p>
                  
                  <div className="text-center md:text-left">
                    <Link 
                      to="/donor-community" 
                      className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-teal-500 text-white font-semibold py-1 px-3 rounded-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-sm"
                      rel="noopener noreferrer"
                      title="login to addazakat"
                    >
                      <FaExternalLinkAlt className="text-sm"/>
                      <span>{translation.join_now}</span>
                    </Link>
                  </div>

                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row-reverse justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-teal-100 to-blue-100 dark:from-teal-900/30 dark:to-blue-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">2</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.donor_processH2}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.donor_process2}
                  </p>
                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-teal-100 to-blue-100 dark:from-teal-900/30 dark:to-blue-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">3</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.donor_processH3}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.donor_process3}
                  </p>
                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row-reverse justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-teal-100 to-blue-100 dark:from-teal-900/30 dark:to-blue-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">4</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.donor_processH4}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.donor_process4}
                  </p>
                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-teal-100 to-blue-100 dark:from-teal-900/30 dark:to-blue-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">5</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.donor_processH5}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.donor_process5}
                  </p>
                </div>
              </motion.article>
            </div>
          </motion.section>

          {/* Process for Receiving Zakat - Step-by-step timeline for clarity, after services to explain how */}
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >

            <motion.section 
              className="relative bg-gradient-to-r from-blue-600 to-teal-500 rounded-3xl p-6 sm:p-8 md:p-10 text-white shadow-2xl overflow-hidden mb-12 md:mb-16 "
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={sectionVariants}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
              <div className="relative z-10 text-center max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">{translation.zakat_process0}</h2>
                <p className="text-lg md:text-xl leading-relaxed">
                  {translation.need_message}
                </p>
              </div>
            </motion.section>

            
        
            <div className="space-y-12 md:space-y-16 relative before:absolute before:inset-0 before:w-1 before:mx-auto before:rounded-full md:before:hidden">
              <motion.article 
                className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-blue-100 to-teal-100 dark:from-blue-900/30 dark:to-teal-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">1</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.zakat_processH1}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.zakat_process1}
                  </p>

                  <div className="text-center md:text-left">
                    <Link 
                      to="/auth/login" 
                      className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-teal-500 text-white font-semibold py-1 px-3 rounded-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-sm"
                      rel="noopener noreferrer"
                      title="login to addazakat"
                    >
                      <FaExternalLinkAlt className="text-sm" />
                      <span>{translation.login_now}</span>
                    </Link>
                  </div>
                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row-reverse justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-blue-100 to-teal-100 dark:from-blue-900/30 dark:to-teal-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">2</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.zakat_processH2}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.zakat_process2}
                  </p>

                  <div className="text-center md:text-left">
                    <button
                      onClick={handleCreatePostClick}
                      className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-teal-500 text-white font-semibold py-1 px-3 rounded-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-sm"
                      title="login to addazakat"
                    >
                      <FaExternalLinkAlt className="text-sm"/>
                      <span>{translation.create_post}</span>
                    </button>
                  </div>

                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-blue-100 to-teal-100 dark:from-blue-900/30 dark:to-teal-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">3</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.zakat_processH3}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.zakat_process3}
                  </p>
                </div>
              </motion.article>

              <motion.article 
                className="flex flex-col md:flex-row-reverse justify-center items-center gap-6 md:gap-10 relative"
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.6 }}
              >
                <div className="bg-gradient-to-br from-blue-100 to-teal-100 dark:from-blue-900/30 dark:to-teal-900/30 rounded-full w-24 h-24 md:w-32 md:h-32 flex items-center justify-center shadow-lg z-10">
                  <h1 className="text-4xl md:text-5xl text-black dark:text-white font-bold">4</h1>
                </div>
                <div className="text-center md:text-left flex-1 max-w-xl">
                  <h3 className="text-2xl md:text-3xl font-bold mb-3">{translation.zakat_processH4}</h3>
                  <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                    {translation.zakat_process4}
                  </p>
                </div>
              </motion.article>
            </div>
          </motion.section>

          

          {/* calculate zakat  */}
          <motion.section 
            className="relative bg-gradient-to-r from-blue-600 to-teal-500 rounded-3xl p-6 sm:p-8 md:p-10 text-white shadow-2xl overflow-hidden mb-12 md:mb-16 "
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
            <div className="relative z-10 text-center max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">{translation.calculate_zakat_hd}</h2>
              <p className="text-lg md:text-xl leading-relaxed">
                {translation.calculate_zakat_msg}
              </p>

              <Link 
                to="/calculate-zakat" 
                className="inline-flex bg-gradient-to-r from-blue-600 to-rose-500 text-white font-semibold py-3 px-6 rounded-full hover:shadow-lg hover:-translate-y-1 transition-all mt-5 duration-300 space-x-2"
              > 
                <FaExternalLinkAlt className="text-xl mx-2" />
                <span>{translation.calculate_zakat_btn}</span>
              </Link>
            </div>

          </motion.section>
          
          {/* Services Grid - Grid for quick scanning, after features to build on who we serve */}
          <motion.section
            initial="hidden"
            className="space-y-5"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-center   bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-teal-500">
              {translation.how_serve}
            </h2>

            <div className="text-center">
              <Link 
                to="/who-to-pay-zakat" 
                className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-teal-500 text-white font-semibold py-1 px-3 rounded-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-sm"
                rel="noopener noreferrer"
                title="Learn who is eligible to receive Zakat"
              >
                <FaExternalLinkAlt className="text-sm" />
                <span>{translation.eligible_to_get_zakat}</span>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
              {/* Family Support */}
              <motion.article 
                className="bg-white dark:bg-gray-800 rounded-3xl p-6 md:p-8 shadow-xl border-l-4 border-blue-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaUsers className="text-4xl text-blue-500" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.family_assistance}</h3>
                </div>
                <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                  {translation.family_ass_msg}
                </p>
              </motion.article>

              {/* Marriage Support */}
              <motion.article 
                className="bg-white dark:bg-gray-800 rounded-3xl p-6 md:p-8 shadow-xl border-l-4 border-pink-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6 ">
                  <FaRing className="text-4xl text-pink-500" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.marriage_support}</h3>
                </div>
                <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 ">
                  {translation.marriage_sup_msg}
                </p>
              </motion.article>

              {/* Medical Assistance */}
              <motion.article 
                className="bg-white dark:bg-gray-800 rounded-3xl p-6 md:p-8 shadow-xl border-l-4 border-green-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaHospital className="text-4xl text-green-500" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.medical_ass}</h3>
                </div>
                <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                  {translation.medical_ass_msg}
                </p>
              </motion.article>

              {/* Institution Support */}
              <motion.article 
                className="bg-white dark:bg-gray-800 rounded-3xl p-6 md:p-8 shadow-xl border-l-4 border-purple-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaMosque className="text-4xl text-purple-500" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.institution_support}</h3>
                </div>
                <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                  {translation.institution_support_msg}
                </p>
              </motion.article>

              {/* Widow/Orphan Support */}
              <motion.article 
                className="bg-white dark:bg-gray-800 rounded-3xl p-6 md:p-8 shadow-xl border-l-4 border-yellow-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaChild className="text-4xl text-yellow-500" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.special_care}</h3>
                </div>
                <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                  {translation.special_care_msg}
                </p>
              </motion.article>

              {/* NGOs */}
              <motion.article 
                className="bg-white dark:bg-gray-800 rounded-3xl p-6 md:p-8 shadow-xl border-l-4 border-cyan-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaBuilding className="text-4xl text-cyan-500" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.NGOs}</h3>
                </div>
                <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
                  {translation.NGOs_msg}
                </p>
              </motion.article>
            </div>
          </motion.section>


          {/* Values Section - Grid at the end to reinforce principles */}
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-teal-500">
              {translation.our_values}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <motion.article 
                className="bg-gradient-to-br from-blue-600 to-teal-500 rounded-3xl p-6 md:p-8 text-white shadow-2xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaHandsHelping className="text-4xl" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.no_fees_ever}</h3>
                </div>
                <p className="text-base md:text-lg">
                  {translation.no_fees_ever_msg}
                </p>
              </motion.article>

              <motion.article 
                className="bg-gradient-to-br from-blue-600 to-teal-500 rounded-3xl p-6 md:p-8 text-white shadow-2xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaPrayingHands className="text-4xl" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.divine_purpose}</h3>
                </div>
                <p className="text-base md:text-lg">
                  {translation.divine_purp_msg}
                </p>
              </motion.article>

              <motion.article 
                className="bg-gradient-to-br from-blue-600 to-teal-500 rounded-3xl p-6 md:p-8 text-white shadow-2xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaGlobe className="text-4xl" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.long_term}</h3>
                </div>
                <p className="text-base md:text-lg">
                  {translation.long_term_msg}
                </p>
              </motion.article>

              <motion.article 
                className="bg-gradient-to-br from-blue-600 to-teal-500 rounded-3xl p-6 md:p-8 text-white shadow-2xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaHeart className="text-4xl" />
                  <h3 className="text-xl md:text-2xl font-bold">{translation.sincere_service}</h3>
                </div>
                <p className="text-base md:text-lg">
                  {translation.sincere_service_msg}
                </p>
              </motion.article>
            </div>
          </motion.section>

          {/* Mission Statement - Follows hero for core message */}
          <motion.section 
            className="relative bg-gradient-to-r from-blue-600 to-teal-500 rounded-3xl p-6 sm:p-8 md:p-10 text-white shadow-2xl overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
            <div className="relative z-10 text-center max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">{translation.our_core}</h2>
              <p className="text-lg md:text-xl leading-relaxed">
                {translation.mission}
              </p>
            </div>
          </motion.section>
          
        </section>
      </main>
    </>
  );
};

export default AboutAddaZakat;